<template>
    <x-page :title="pageTitle">
        <template #header-actions>
            <x-back-button :disabled="isLoading" :display-warning="false" />
        </template>
        <metric-record-form id="metric-record-form"
            v-if="resource"
            :disabled="true"
            :initialFields="resource" />
    </x-page>
</template>

<script>
import XBackButton from '../../components/XBackButton.vue'
import XPage from '../../components/XPage.vue'
import { formatForDateInput, handleGeneralXhrError } from '../../helpers'
import MetricRecordForm from './MetricRecordForm.vue'
import MetricRecordFormMixin from './mixins/MetricRecordFormMixin'

export default {
    components: {
        XPage,
        XBackButton,
        MetricRecordForm,
    },
    computed: {
        pageTitle() {
            return `Metric Record | ${this.resource?.name}`
        }
    },
    created() {
        this.fetchResource()
    },
    data() {
        return {
            errors: null,
            isLoading: false,
            resource: null,
        }
    },
    methods: {
        fetchResource() {
            this.isLoading = true
            const request = axios.get(`/api/metric-records/${this.$route.params.id}`, {
                params: {
                    load: 'values'
                }
            })
            .then(response => {
                const resource = response.data.data
                this.resource = {
                    ...resource,
                    date: formatForDateInput(resource.date),
                    values: this.parseServerMetrics(resource.values),
                }
            })
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false
            })
        },
    },
    mixins: [
        MetricRecordFormMixin,
    ],
}
</script>